// Curated palette for the public North Star microsite.
// Goal: premium editorial feel, but with enough color rhythm that the page
// doesn't read as flat or sparse. Designed to look good both on screen and in
// print (no neons, no pure pastels).

export const INK = '#1a1a1a'
export const INK_MUTED = '#5a5a5a'
export const PAPER = '#fbf9f4'
export const DIVIDER = '#dcd7cb'

// Three path-accent colors used across charts, badges, deep-dive headers,
// trajectory lines, and wildcards groupings. Order matters — path 0 is the
// recommended path so its color reads as the "primary" thread of the document.
export const PATH_COLORS = [
  '#3a5a3a', // forest — recommended path (signals "go here")
  '#c9954a', // amber — viable alternative
  '#5d7a8c', // slate blue — supporting / wildcard option
] as const

export const PATH_TINTS = [
  'rgba(58, 90, 58, 0.05)',
  'rgba(201, 149, 74, 0.06)',
  'rgba(93, 122, 140, 0.06)',
] as const

// Section background washes — used in SectionContainer to break up the page
// vertically. Keyed by sectionTypeId. Fall back to PAPER if no tint registered.
export const SECTION_TINTS: Record<string, string> = {
  hero: 'transparent', // hero handles its own background (gradient)
  orientation: 'transparent',
  choices: 'rgba(201, 149, 74, 0.045)',
  'deep-dive': 'transparent',
  'reality-check': 'rgba(93, 122, 140, 0.055)',
  trajectory: 'rgba(58, 90, 58, 0.04)',
  wildcards: 'rgba(170, 90, 90, 0.045)',
  bridge: 'rgba(201, 149, 74, 0.04)',
  decision: 'rgba(58, 90, 58, 0.07)',
}

// Fit score → color ramp. Bumps up the visual signal vs a single accent.
export function scoreColor(score?: number): string {
  if (typeof score !== 'number') return '#a3a3a3'
  if (score >= 90) return '#2d5a3d' // deep forest
  if (score >= 80) return '#4a7a4a' // green
  if (score >= 70) return '#c9954a' // amber
  if (score >= 60) return '#aa5a5a' // rust
  return '#7a7a7a' // muted
}

export function scoreBackground(score?: number): string {
  const c = scoreColor(score)
  // 12% opacity over paper for a visible tinted chip
  return `${c}1f`
}

// Pick a path color by index with safe fallback if more than 3 paths exist
export function pathColor(index: number): string {
  return PATH_COLORS[index % PATH_COLORS.length]
}
export function pathTint(index: number): string {
  return PATH_TINTS[index % PATH_TINTS.length]
}
